import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { forwardRef } from 'react';
import { StyledCheckbox, StyledFormControlLabel, StyledIcon } from './checkbox.styles';
import checkboxIcon from '@images/checkbox-icon.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(StyledFormControlLabel, {
    control: /*#__PURE__*/_jsx(StyledCheckbox, _objectSpread({
      ref: ref,
      icon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      }),
      checkedIcon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      }),
      indeterminateIcon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      })
    }, props)),
    label: props.label
  });
});
Checkbox.displayName = 'Checkbox';
export { Checkbox };